import { render, staticRenderFns } from "./RegisterOtherInfo.vue?vue&type=template&id=47d809dd&"
import script from "./RegisterOtherInfo.vue?vue&type=script&lang=js&"
export * from "./RegisterOtherInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports